module.exports = __webpack_public_path__ + "static/img/Manual Fruit Count_2x3.f4b6a3a6.webp";